import React from "react";
import { Link, useLocation } from "react-router-dom";
import RecentDashboards from "./RecentDashboards";
import "./TopNavigation.css";

function TopNavigation() {
  const location = useLocation();

  const navItems = [
    {
      id: 'project-list',
      label: 'Projects',
      path: '/',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4C4 3.44772 4.44772 3 5 3H15C15.5523 3 16 3.44772 16 4V16C16 16.5523 15.5523 17 15 17H5C4.44772 17 4 16.5523 4 16V4Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <circle cx="8" cy="8" r="1"
            fill="currentColor"
          />
          <path d="M10 8H13"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="8" cy="12" r="1"
            fill="currentColor"
          />
          <path d="M10 12H13"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )
    },
    {
      id: 'contact-management',
      label: 'Contacts',
      path: '/contacts/manage',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 17V15C16 13.9391 15.5786 12.9217 14.8284 12.1716C14.0783 11.4214 13.0609 11 12 11H8C6.93913 11 5.92172 11.4214 5.17157 12.1716C4.42143 12.9217 4 13.9391 4 15V17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M10 7C11.6569 7 13 5.65685 13 4C13 2.34315 11.6569 1 10 1C8.34315 1 7 2.34315 7 4C7 5.65685 8.34315 7 10 7Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    },
    {
      id: 'account-management',
      label: 'Accounts',
      path: '/accounts',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" />
          <path d="M10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" stroke="currentColor" strokeWidth="2" />
          <path d="M4 16c0-2.209 2.686-4 6-4s6 1.791 6 4" stroke="currentColor" strokeWidth="2" />
        </svg>
      )
    },
    {
      id: 'inventory-management',
      label: 'Inventory',
      path: '/inventory',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 6l7-3 7 3v8l-7 3-7-3V6z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <path d="M3 6l7 3 7-3M10 9v9" stroke="currentColor" strokeWidth="2" />
        </svg>
      )
    },
    {
      id: 'equipment-management',
      label: 'Equipment',
      path: '/equipment',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 13h10.5a2.5 2.5 0 0 0 2.45-2H18V8.5h-2.2l-1.3-2.2A2 2 0 0 0 12.8 5H8.5L7 7H3v6z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
          <circle cx="6.5" cy="14.5" r="1.6" stroke="currentColor" strokeWidth="1.6" />
          <circle cx="13.5" cy="14.5" r="1.6" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      )
    },
    {
      id: 'archive',
      label: 'Archive',
      path: '/archive',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="14" height="4" rx="1" stroke="currentColor" strokeWidth="2" />
          <rect x="4" y="7" width="12" height="10" rx="1" stroke="currentColor" strokeWidth="2" />
          <path d="M7 11H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      )
    }
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <nav className="top-navigation">
      {navItems.map((item) => (
        <Link
          key={item.id}
          to={item.path}
          className={`top-nav-item ${isActive(item.path) ? 'active' : ''}`}
          title={item.label}
          aria-label={item.label}
        >
          {item.icon}
          <span className="top-nav-label">{item.label}</span>
        </Link>
      ))}
      <RecentDashboards />
    </nav>
  );
}

export default TopNavigation;

